// react
import PropTypes from "prop-types";
import React from "react";

// components
import Radio from "../../../../../../components/Inputs/Radio";
import RadioButtons from "../../../../../../components/Inputs/SelectionOptions/RadioButtons";

// styles
import css from "./NotificationSetting.module.scss";

/**
 * Renders a row in the notification settings table. It will render a label and
 * a radio button for each option passed in the `options` prop.
 * @param {*} props
 */
const NotificationSetting = (props) => {
	const { className = "", options, label, state = null, requestingNotification = null, onChange } = props;

	const changeNotification = (nextState) => {
		onChange(nextState);
	};

	return (
		<div data-testid="notificationSetting" className={`${css.settingMain} ${className}`}>
			<div className={`${css.bodyCell}`}>{label}</div>

			{options.map((option) => (
				<div
					data-testid={String(option.name)}
					key={option.name}
					className={`${css.bodyCell} ${css.toggleSwitchCell}`}
				>
					<Radio
						onChange={() => changeNotification(option.name)}
						size={20}
						value={state === option.name}
						isLoading={requestingNotification === option.name}
					/>
				</div>
			))}
		</div>
	);
};

NotificationSetting.propTypes = {
	// any additional class names
	className: PropTypes.string,
	// the id of the current selected option
	state: PropTypes.string,
	// hook when the user changes the selected option
	onChange: PropTypes.func.isRequired,
	// options for the radio buttons
	options: PropTypes.array.isRequired,
	// human-friendly label
	label: PropTypes.string.isRequired,
	// are we waiting on a request
	requestingNotification: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default NotificationSetting;
